module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAHdElNRQfkBBQQFSflY2UzAAAAh0lEQVRIx+3VoQ7CQAzG8f/RZITnQfBGJ6dw6AmSS0jm9p5M7DYCAnnmu+UU9JNt8xMVbYhIGegZuZWNqagEkdwwMkeFPGgiBnTaqEpWxEknnXTyJ8kQB67qcRWSSSEuDUGAp51PXLBm4MpDfWfv75rKxv53VhEnnXTSyb8mX0BuS96ZSdroB/4BE5pl/8AVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contacts_icon_add.png
// module id = T7Ws
// module chunks = 1